var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pub-page-title"},[_c('div',{staticClass:"pub-page-title-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"pub-page-title-option"},[_vm._t("titleRight")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }